<template>
    <ul
        v-show="visible"
        :class="{ 'is-visible': visible }"
        class="el-select-group__wrap"
    >
        <li class="el-select-group__title">
            {{ label }}
        </li>
        <li>
            <ul class="el-select-group">
                <slot />
            </ul>
        </li>
    </ul>
</template>

<script setup>
import { ref, watch, inject, provide, onMounted } from 'vue';

const props = defineProps({
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
});

const select = inject('select', null);
const optionRefs = ref([]);
const option = inject('option', null);

const visible = ref(true);

function registerGroupOption(payload) {
    optionRefs.value.push(payload);
}

function unregisterGroupOption(payload) {
    const idx = optionRefs.value.indexOf(payload);
    if (idx !== -1) optionRefs.value.splice(idx, 1);
}

function queryChange() {
    visible.value = optionRefs.value.some(opt => opt.visible !== false);
}


watch(() => props.disabled, (val) => {
    option?.handleGroupDisabled?.(val);
});

watch(() => select.query?.value, (val) => {
    queryChange(val);
});

onMounted(() => {
    if (props.disabled) {
        option?.handleGroupDisabled?.(props.disabled);
    }
});

provide('optionGroup', {
    registerGroupOption,
    unregisterGroupOption,
});
</script>

<style scoped lang="postcss">
.el-select-group {
    &__wrap {
        position: relative;
        list-style: none;
        margin: 0;
        &.is-visible {
            &:has(+ .el-select-group__wrap.is-visible) {
                border-bottom: 1px solid var(--av-brand-light);
                padding-bottom: 16px;
                margin-bottom: 16px;
            }
        }
    }
    &__title {
        padding-inline-start: 20px;
        font-size: 14px;
        color: var(--av-fixed-light);
        line-height: 30px;
    }
    :deep(.el-select-dropdown__item) {
        padding-inline-start: 20px;
    }
}
</style>
